import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const CardHeader = {
  borderBottom: `1px solid ${COLORS.LINK_WATER}`,
}

export const ContainerHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '60px',
  maxWidth: '1920px',
  paddingX: 2,
  [PureLightTheme.breakpoints.down("md")]: {
    maxWidth: "760px",
    paddingX: 1.5,
  }
}

export const BoxHeaderLogo = {
  marginRight: 4.5,
  height: '30px',
}

export const StyledHeaderLink = {
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
  '&.active': {
    '& .MuiTypography-root': {
      color: COLORS.BLACK,
    },
  },
}

export const BoxHeaderNav = {
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  '& a.headerNavLink': StyledHeaderLink,
}
